import {
  Building2, Users, MapPin, Mail, Gauge, Trash2, Send, CheckCircle2, Sparkles, MoreVertical,
} from "lucide-react";
import { SepaStatusBadge } from "@/components/SepaStatusBadge";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

// Lista condomìni in stile "posta": colonna verticale compatta; il click seleziona il condominio
// e ne mostra tutti i dettagli nel pannello a destra.
export const BuildingsList = ({ buildings, selectedId, onSelect, onDelete, onPresent }) => (
  <div data-testid="buildings-list" className="divide-y divide-border">
    {buildings.map((b, i) => (
      <div key={b.id} data-testid={`building-row-${i}`} onClick={() => onSelect(b)}
        className={`list-enter group flex items-start gap-2.5 px-3 py-3 cursor-pointer transition-colors duration-150 border-l-4 ${selectedId === b.id ? "bg-[#EBF3FF] border-l-[#007BFF]" : "border-l-transparent hover:bg-secondary/60"}`}
        style={{ animationDelay: `${Math.min(i, 12) * 25}ms` }}>
        <div className="h-9 w-9 rounded-md bg-[#007BFF]/10 flex items-center justify-center shrink-0 mt-0.5">
          <Building2 className="h-5 w-5 text-[#007BFF]" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-1.5">
            <h4 className="font-semibold text-sm tracking-tight truncate max-w-full">{b.name}</h4>
            {b.source === "danea" && <span className="text-[9px] uppercase tracking-wider bg-[#007BFF]/10 text-[#007BFF] px-1.5 py-0.5 rounded shrink-0">Danea</span>}
            {b.subscription_status === "non_abbonato" && <span data-testid={`building-not-subscribed-${i}`} title="Condominio non collegato — attivalo in Acquisti e collegamento" className="text-[9px] uppercase tracking-wider bg-amber-100 text-amber-700 border border-amber-200 px-1.5 py-0.5 rounded shrink-0">Non collegato</span>}
            <SepaStatusBadge status={b.sepa_status} className="shrink-0" />
          </div>
          <div className="text-xs text-muted-foreground truncate mt-0.5 flex items-center gap-1"><MapPin className="h-3 w-3 shrink-0" />{b.address || "—"}{b.citta ? `, ${b.citta}` : ""}</div>
          <div className="flex items-center gap-3 mt-1.5 flex-wrap">
            <span className="text-xs text-muted-foreground flex items-center gap-1" title="Condòmini"><Users className="h-3.5 w-3.5" />{b.residents_count}</span>
            <span data-testid={`building-millesimi-${i}`} className="text-xs text-muted-foreground flex items-center gap-1" title="Totale millesimi"><Gauge className="h-3.5 w-3.5" />{Number(b.millesimi_total || 0).toLocaleString("it-IT")}</span>
            <span data-testid={`building-mail-count-${i}`} className="text-xs font-medium text-[#007BFF] bg-[#007BFF]/10 rounded-full px-2 py-0.5 flex items-center gap-1" title="Email ricevute da questo condominio"><Mail className="h-3.5 w-3.5" />{b.mail_count || 0}</span>
            {b.presentation_sent_at && b.presentation_new_count > 0 && (
              <span data-testid={`present-new-badge-${i}`} className="inline-flex items-center gap-1 text-[10px] font-semibold text-[#007BFF] bg-[#007BFF]/10 rounded-full px-2 py-0.5" title="Nuovi condòmini a cui non è stata inviata la presentazione">
                <Sparkles className="h-3 w-3" />{b.presentation_new_count} nuovi
              </span>
            )}
          </div>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button type="button" data-testid={`building-menu-${i}`} aria-label="Azioni condominio"
              onClick={(e) => e.stopPropagation()}
              className="shrink-0 text-muted-foreground hover:text-foreground p-1.5 rounded hover:bg-secondary transition-colors duration-150">
              <MoreVertical className="h-4 w-4" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-60" onClick={(e) => e.stopPropagation()}>
            {b.presentation_sent_at ? (
              <>
                <DropdownMenuLabel className="text-xs font-normal text-muted-foreground flex items-center gap-1.5">
                  <CheckCircle2 className="h-3.5 w-3.5 text-green-600" />Presentazione inviata a {b.presentation_sent_count || 0}
                </DropdownMenuLabel>
                <DropdownMenuItem data-testid={`present-resend-${i}`} disabled={!b.presentation_new_count}
                  onClick={(e) => { e.stopPropagation(); onPresent(b, true); }} className="cursor-pointer">
                  <Send className="h-3.5 w-3.5 mr-2 text-[#007BFF]" />
                  {b.presentation_new_count ? `Reinvia ai nuovi (${b.presentation_new_count})` : "Nessun nuovo condòmino"}
                </DropdownMenuItem>
              </>
            ) : (
              <DropdownMenuItem data-testid={`present-building-${i}`} disabled={b.subscription_status === "non_abbonato"}
                onClick={(e) => { e.stopPropagation(); if (b.subscription_status !== "non_abbonato") onPresent(b, false); }}
                className="cursor-pointer">
                <Sparkles className="h-3.5 w-3.5 mr-2 text-[#007BFF]" />Presenta Sedio ai condòmini
              </DropdownMenuItem>
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid={`delete-building-${i}`}
              onClick={(e) => { e.stopPropagation(); onDelete(b); }}
              className="cursor-pointer text-red-600 focus:text-red-600">
              <Trash2 className="h-3.5 w-3.5 mr-2" />Elimina condominio
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    ))}
  </div>
);
